export default "__VITE_ASSET__DY_Fo6xp__"